import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
// ----- Imports ----- //
import { css } from '@emotion/react';
import { from, palette, space } from '@guardian/source/foundations';
import { LinkButton, SvgArrowRightStraight, themeButtonReaderRevenueBrand, } from '@guardian/source/react-components';
import Rows from 'components/base/rows';
import { themeButtonLegacyGray } from 'components/button/theme';
import Footer from 'components/footerCompliant/Footer';
import Header from 'components/headers/header/header';
import { PageScaffold } from 'components/page/pageScaffold';
import PageSection from 'components/pageSection/pageSection';
import Text, { LargeParagraph } from 'components/text/text';
import { CountryGroup } from 'helpers/internationalisation/classes/countryGroup';
import { contributionsEmail } from 'helpers/legal';
import { gu_v_spacing } from 'stylesheets/emotion/layout';
import SquaresIntroduction from './introduction/squaresIntroduction';
const countryGroupId = CountryGroup.detect();
const mainContentStyles = css `
	background-color: ${palette.neutral[93]};
	display: block !important; // old layout pages need to stay the same
`;
const paddingOverrides = css `
	padding-top: ${gu_v_spacing * 2}px;
	padding-bottom: ${gu_v_spacing * 3}px;
`;
const buttonRow = css `
	display: flex;
	flex-direction: column;
	gap: ${space[3]}px;

	${from.tablet} {
		> a {
			width: fit-content;
		}
	}
`;
export default function ErrorPage(props) {
    return (_jsx(PageScaffold, { header: _jsx(Header, { countryGroupId: countryGroupId }), footer: _jsx(Footer, {}), children: _jsxs("div", { css: mainContentStyles, children: [_jsx(SquaresIntroduction, { headings: props.headings, errorCode: props.errorCode }), _jsx(PageSection, { cssOverrides: paddingOverrides, children: _jsxs(Text, { children: [_jsxs(LargeParagraph, { children: [_jsxs("span", { className: "error-copy__text", children: [props.copy, " "] }), _jsx(ReportLink, { show: props.reportLink ?? false })] }), _jsx(Rows, { children: _jsxs("div", { css: buttonRow, children: [props.supportLink && (_jsx(LinkButton, { href: "/", "aria-label": "click here to support the Guardian", theme: themeButtonReaderRevenueBrand, size: "small", icon: _jsx(SvgArrowRightStraight, {}), iconSide: "right", children: "Support the Guardian" })), _jsx(LinkButton, { href: "https://www.theguardian.com", "aria-label": "click here to return to the Guardian home page", priority: "tertiary", theme: themeButtonLegacyGray, size: "small", icon: _jsx(SvgArrowRightStraight, {}), iconSide: "right", children: "Go to the Guardian home page" })] }) })] }) })] }) }));
} // ----- Auxiliary Components ----- //
function ReportLink(props) {
    if (props.show) {
        return (_jsxs("span", { className: "error-copy__text", children: ["please", ' ', _jsx("a", { className: "error-copy__link", href: contributionsEmail.GBPCountries, children: "report it" }), "."] }));
    }
    return null;
}
// ----- Default Props ----- //
ErrorPage.defaultProps = {
    reportLink: false,
    supportLink: true,
    errorCode: null,
};
